import type { AfterResponseHook } from 'ky';
import { HTTP_HEADERS, REDIRECT_TO_KEY } from '../../../../auth/const';
import isNative from '../../../native/isNative';
import { addTenantPrefix } from '../../../tenantBasePath';
import { isServer } from '../../utils';
import type { HookGetterArgs } from '../types';

export const handleExpiredPassword = ({ options }: HookGetterArgs): AfterResponseHook => {
  const handleExpiredPasswordHook: AfterResponseHook = (_req, _opts, response) => {
    if (
      !isServer() &&
      !isNative() &&
      // disable auto redirect for cors domain
      !options.credentials &&
      response.headers.get(HTTP_HEADERS.ExpiredPassword) === 'true' &&
      // if the pathname is already update-password, don't redirect
      !window.location.pathname.includes('/update-password')
    ) {
      const currentPath = window.location.pathname + window.location.search;
      const redirectURL = new URL('/update-password', window.location.origin);
      redirectURL.searchParams.set(REDIRECT_TO_KEY, currentPath);
      window.location.href = addTenantPrefix(
        redirectURL.toString(),
        options.meta?.basePath,
      ).toString();
    }
  };
  return handleExpiredPasswordHook;
};
